import { createBrowserHistory } from 'history'
import React from 'react'
import { hydrate, render } from 'react-dom'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import * as serviceWorker from './serviceWorker'
import store from './store/store'

import App from './App'

const hist = createBrowserHistory()

// Load runtime configuration before rendering the app
const loadRuntimeConfig = () => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = '/config/runtime-config.js';
    script.onload = () => {
      console.log('Runtime config loaded:', window.RUNTIME_CONFIG);
      resolve(window.RUNTIME_CONFIG);
    };
    script.onerror = () => {
      console.warn('Failed to load runtime config, using defaults');
      // Fallback configuration
      window.RUNTIME_CONFIG = {
        REACT_APP_API_URL: '/api/',
        REACT_APP_BASE_URL: '/',
        REACT_APP_SERVER_IP: window.location.hostname
      };
      resolve(window.RUNTIME_CONFIG);
    };
    document.head.appendChild(script);
  });
};

const renderApp = () => {
  const rootElement = document.getElementById('app')
  const app = (
    <Provider store={store}>
      <Router history={hist}>
        <ScrollToTop />
        <App />
      </Router>
    </Provider>
  )
  
  if (rootElement.hasChildNodes()) {
    hydrate(app, rootElement)
  } else {
    render(app, rootElement)
  }
}

// Load config and then render
loadRuntimeConfig().then(() => {
  renderApp();
  serviceWorker.register();
});
